// extracted by mini-css-extract-plugin
export default {"interest":"IndustriesCard_interest__QZvoi"};